<template>
  <div class=""
       data-dusk="attachable-actions">
        <a-dropdown class="actions" :trigger="['click']">
          <a-button type="default" >
            Acties
            <a-icon type="down"/>
          </a-button>
          <template #overlay>
            <a-menu>
              <a-menu-item @click="onDownloadClick"
                           data-dusk="download">
                <download-icon/>
                Downloaden
              </a-menu-item>
              <a-menu-item @click="onCopyClick"
                           data-dusk="copy">
                <content-copy-icon/>
                Kopieer naar
              </a-menu-item>

              <a-menu-item @click="onMoveClick"
                           data-dusk="move">
                <content-cut-icon/>
                Verplaats naar
              </a-menu-item>

              <a-menu-item @click="onEditClick"
                           data-dusk="edit">
                <pencil-icon/>
                Bewerken
              </a-menu-item>

              <a-menu-item v-if="hasCustomer"
                           @click="onPublishToggleClick">
                 <span v-if="!row.visible_for_customer">
                  <eye-icon/>
                  Publiceren
                </span>
                <span v-if="row.visible_for_customer">
                  <eye-off-icon/>
                  Onpubliceren
                </span>
              </a-menu-item>

              <a-menu-item v-else-if="!hasCustomer"
                           @click="onPublishToggleClick">
                <span v-if="!row.is_public">
                  <eye-icon/>
                  Publiceren
                </span>
                <span v-if="row.is_public">
                  <eye-off-icon/>
                  Onpubliceren
                </span>
              </a-menu-item>
              <a-menu-item @click="onDeleteClick"
                           data-dusk="delete">
                <delete-icon/>
                Verwijderen
              </a-menu-item>
            </a-menu>
          </template>
        </a-dropdown>
  </div>

</template>

<script>
import { mapState, mapMutations,mapActions } from 'vuex';
export default {
  name: "DocumentActions",
  props: {
    row: {
      type: Object,
      required: true,
    },
    category: Object,
  },
  computed: {
    ...mapState(`$_attachable_widget`, {
      selectedAttachables: 'selectedAttachables',
    }),
    hasCustomer() {
      return this.row.customer_id !== null;
    },
  },
  methods: {
    ...mapActions(`$_attachable_widget`, {
      updateAttachable: 'updateAttachable',
    }),
    ...mapMutations(`$_attachable_widget`, {
      updateAttachableState: 'UPDATE_ATTACHABLE',
      setSelectedAttachables: 'SET_SELECTED_ATTACHABLES',
      setShowCopyModal: 'SET_SHOW_COPY_MODAL',
      setShowDeleteModal: 'SET_SHOW_DELETE_MODAL',
      setShowMoveModal: 'SET_SHOW_MOVE_MODAL',
      setEditingAttachable: 'SET_EDITING_ATTACHABLE_WITH_ID'
    }),
    onDownloadClick() {
      let documentModel = this.row?.child_instance?.data;
      if (!documentModel) return
      const link = document.createElement('a');
      link.href = documentModel.show_link;
      link.download = documentModel.name;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    selectThisAttachable() {
      this.setSelectedAttachables({attachables: [this.row], id: this.category.id} );
    },
    onCopyClick() {
      this.selectThisAttachable();
      this.setShowCopyModal(true);
    },
    onMoveClick() {
      this.selectThisAttachable();
      this.setShowMoveModal(true);
    },
    onDeleteClick() {
      this.selectThisAttachable();
      this.setShowDeleteModal(true);
    },
    onPublishToggleClick() {
      if (this.hasCustomer) {
        this.row.visible_for_customer = !this.row.visible_for_customer;
      }
      else {
        this.row.is_public = !this.row.is_public;
      }
      this.updateAttachable(this.row);
      this.updateAttachableState({attachable: this.row });
    },
    onEditClick() {
      this.setEditingAttachable(this.row.id);
      this.updateAttachableState({attachable: this.row });
    },
  }
};
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
</style>
